export default __webpack_public_path__ + "static/media/mint.8655d3dd.mp4";